export enum ETransactionProgress {
  creating,
  sending_to_solana,
  waiting_for_confirmation,
  loading_account,
}
